export enum SocketActionsEnum {
  FORCE_LOG_OUT = 'FORCE_LOG_OUT',
  UPDATE_DATASOURCE = 'UPDATE_DATASOURCE'
}
